import { render } from "./PlayoutTableEmpty.vue?vue&type=template&id=10dd227c"
import script from "./PlayoutTableEmpty.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutTableEmpty.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TVPlayout/PlayoutTableEmpty.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10dd227c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10dd227c', __exports__)) {
    api.reload('10dd227c', __exports__)
  }
  
  module.hot.accept("./PlayoutTableEmpty.vue?vue&type=template&id=10dd227c", () => {
    api.rerender('10dd227c', render)
  })

}


export default __exports__